import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {GruppeMedlemListeModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {AvatarKomponent, avatarStil} from "web-ng2/delt/komponenter/avatar/avatar";
import {MatTooltip} from "@angular/material/tooltip";
import {TranslateModule} from "@ngx-translate/core";
import {FormaterZonedDateTimePipe} from "felles-ng2/pipes/FormaterZonedDateTimePipe";
import {FormaterMobilnummerPipe} from "felles-ng2/pipes/FormaterMobilnummerPipe";
import {LokaleKomponent} from "web-ng2/delt/komponenter/lokale/lokale";
import {TidssoneKomponent} from "web-ng2/delt/komponenter/tidssone/tidssone";
import {FormaterDatoPeriodeUtenTidPipe} from "felles-ng2/pipes/FormaterDatoPeriodeUtenTidPipe";
import {TittelVerdiSamlingKomponent} from "web-ng2/delt/komponenter/tittel-verdi/tittel-verdi-samling";
import {TittelKomponent, TittelVerdiKomponent, VerdiKomponent} from "web-ng2/delt/komponenter/tittel-verdi/tittel-verdi";

const debug = initDebugger('MedlemInformasjonKomponent');

@Component({
    selector: 'medlem-informasjon',
    templateUrl: './medlem-informasjon.html',
    styleUrl: './medlem-informasjon.scss',
    imports: [
        AvatarKomponent,
        MatTooltip,
        FormaterDatoPeriodeUtenTidPipe,
        TranslateModule,
        FormaterZonedDateTimePipe,
        FormaterMobilnummerPipe,
        LokaleKomponent,
        TidssoneKomponent,
        TittelVerdiSamlingKomponent,
        TittelVerdiKomponent,
        TittelKomponent,
        VerdiKomponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MedlemInformasjonKomponent {

    medlem = input.required<GruppeMedlemListeModell>();
    avatarStil = input<avatarStil>('stor');

    constructor() {
    }

}
